import { createTheme } from "@mui/material/styles";

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#1976d2",
      light: "#4791db",
      dark: "#115293",
      contrastText: "#FFFFFF",
    },
    secondary: {
      main: "#BCE910",
      light: "#D6FF47",
      dark: "#9BC107",
    },
    secondaryShades: {
      100: "#FFFFFF",
      200: "#E8F5E9",
      300: "#D3E5F6",
      400: "#D4DCFF",
      500: "#C1C7FF",
      600: "#B7B6FF",
      700: "#B8B7FF",
      800: "#B7B8FF",
      900: "#B7B8FF",
    },
    secondaryAlt: {
      100: "#3499F3",
      200: "#5F4CF5",
      300: "#A58FF7",
      400: "#8FCFF7",
      500: "#CD6FF7",
      600: "#E8D7F7",
    },
    typography: {
      100: "#FFFFFF",
      200: "#AEAEAE",
      300: "#929295",
      400: "#525459",
    },
    orange: {
      100: "#FC665C",
      200: "#FC7D5E",
      300: "#FC885F",
      400: "#FC9A63",
    },
    yellow: {
      100: "#FFC700",
      200: "#FF7D0F",
      300: "#FFD633",
      400: "#FFEA19",
    },
    green: {
      100: "#C6EA19",
      200: "#CBEFC7",
      300: "#DCE754",
      400: "#D7E7B8",
    },
    background: {
      default: "#121212",
      paper: "#1E1E1E",
    },
    text: {
      primary: "#FFFFFF",
      secondary: "#B3B3B3",
    },
    divider: "#F3F4F6",
    grey: {
      50: "#F8F9FA",
      100: "#F3F4F6",
      200: "#E5E7EB",
      300: "#D1D5DB",
      400: "#9CA3AF",
      500: "#6B7280",
      600: "#4B5563",
      700: "#374151",
      800: "#1F2937",
      900: "#111827",
    },
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
    ].join(","),
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
  sidebar: {
    primary: "#1976d2",
    secondary: "#232c5c",
    text: {
      primary: "#FFFFFF",
      secondary: "#1976d2",
    },
    hover: "rgba(25, 118, 210, 0.18)",
    active: "rgba(25, 118, 210, 0.28)",
    divider: "#F3F4F6",
    iconSize: "12px",
    tableIconSize: "12px",
    gray07: "#6b7280",
    fontSize: "13px",
  },
  button: {
    primary: "#1976d2",
  },
});

export default darkTheme;
